module.exports = __webpack_public_path__ + "static/media/spadal.1173045b.mp4";